import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import SelectOrCreate from 'modules/core/components/SelectOrCreate'
import i18n from 'modules/core/lib/i18n'

import { OptionItem } from 'modules/expenses/hooks/useExpensesCustomization'
import { CategoryOption } from 'modules/finance/lib/policy_types'

interface Props {
  title: string
  description: string
  categories: OptionItem[]
  handleSubmit: (categories: OptionItem[]) => void
  handleClose: () => void
  multiple?: boolean
}

export const AddRuleModal = ({
  title,
  description,
  categories,
  handleSubmit,
  handleClose,
  multiple = true,
}: Props) => {
  const [selectedCategories, setSelectedCategory] = useState<CategoryOption[]>([])

  const onChangeItem = (items: string[]) => {
    const filteredCategories = categories.filter((category: CategoryOption) =>
      items.includes(category.value.toString())
    )
    setSelectedCategory(filteredCategories)
  }

  return (
    <Modal
      illustration="template"
      title={title}
      description={description}
      onSubmit={() => handleSubmit(selectedCategories)}
      onClose={handleClose}
      footer={
        <>
          <Button type="secondary" onClick={() => handleClose()}>
            {i18n.t('common.close')}
          </Button>
          <Button submit>{i18n.t('common.add')}</Button>
        </>
      }
    >
      <SelectOrCreate.Popover
        mandatory={false}
        label=""
        placeholder={i18n.t('common.select_basic')}
        values={selectedCategories.map((category) => category.value)}
        isMultiSelect={multiple}
        onChange={(items) => {
          onChangeItem(items.map((item) => item.toString()))
        }}
        onValuesChange={(items) => {
          onChangeItem(items.map((item) => item.toString()))
        }}
      >
        {categories.map((category) => {
          return (
            <SelectOrCreate.Option
              key={category.id}
              label={category.label}
              value={category.value}
              searchValue={category.label}
            >
              {category.label}
            </SelectOrCreate.Option>
          )
        })}
      </SelectOrCreate.Popover>
    </Modal>
  )
}
